import { P, match } from 'ts-pattern';
import isEmail from 'validator/lib/isEmail';

const ALLOWED_PROTOCOLS = ['http://', 'https://', 'mailto:'];

export default function addProtocolToUrl(link?: string | null) {
  return match(link)
    .with(null, '', undefined, () => '')
    .with(
      P.when((link) => ALLOWED_PROTOCOLS.some((protocol) => link.startsWith(protocol))),
      (link) => link
    )
    .with(P.when(isEmail), () => `mailto:${link}`)
    .otherwise((link) => `https://${link}`);
}
